import React, { useState } from "react";

// Mini Map Component for table cells
const MiniLocationMap = ({ latitude, longitude, label, onClick }) => {
  if (!latitude || !longitude) {
    return <span style={{ color: "#999", fontSize: "12px" }}>No location</span>;
  }

  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${
    parseFloat(longitude) - 0.01
  },${parseFloat(latitude) - 0.01},${parseFloat(longitude) + 0.01},${
    parseFloat(latitude) + 0.01
  }&layer=mapnik&marker=${latitude},${longitude}`;

  return (
    <div
      onClick={onClick}
      style={{
        width: "80px",
        height: "60px",
        border: "2px solid #ddd",
        borderRadius: "8px",
        overflow: "hidden",
        cursor: "pointer",
        position: "relative",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <iframe
        src={mapUrl}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          pointerEvents: "none",
        }}
        title={`${label} location`}
      />
      <div
        style={{
          position: "absolute",
          bottom: "2px",
          left: "2px",
          right: "2px",
          background: "rgba(0,0,0,0.7)",
          color: "white",
          fontSize: "9px",
          padding: "2px 4px",
          borderRadius: "3px",
          textAlign: "center",
        }}
      >
        Click to zoom
      </div>
    </div>
  );
};

// Full Location Modal
const LocationModal = ({ isOpen, onClose, record }) => {
  if (!isOpen || !record) return null;

  const hasPunchIn = record.punchInLatitude && record.punchInLongitude;
  const hasPunchOut = record.punchOutLatitude && record.punchOutLongitude;

  const punchInUrl = hasPunchIn
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${
        parseFloat(record.punchInLongitude) - 0.005
      },${parseFloat(record.punchInLatitude) - 0.005},${
        parseFloat(record.punchInLongitude) + 0.005
      },${
        parseFloat(record.punchInLatitude) + 0.005
      }&layer=mapnik&marker=${record.punchInLatitude},${record.punchInLongitude}`
    : null;

  const punchOutUrl = hasPunchOut
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${
        parseFloat(record.punchOutLongitude) - 0.005
      },${parseFloat(record.punchOutLatitude) - 0.005},${
        parseFloat(record.punchOutLongitude) + 0.005
      },${
        parseFloat(record.punchOutLatitude) + 0.005
      }&layer=mapnik&marker=${record.punchOutLatitude},${record.punchOutLongitude}`
    : null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          maxWidth: "1000px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "24px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2 style={{ margin: 0, fontSize: "24px", color: "#1f2937" }}>
              Attendance Location Details
            </h2>
            <p style={{ margin: "8px 0 0 0", color: "#6b7280", fontSize: "14px" }}>
              {record.employeeName} • {record.attendanceDate}
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "32px",
              cursor: "pointer",
              color: "#9ca3af",
              lineHeight: 1,
              padding: "0",
              width: "40px",
              height: "40px",
              borderRadius: "8px",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f3f4f6";
              e.currentTarget.style.color = "#1f2937";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#9ca3af";
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: "24px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: hasPunchIn && hasPunchOut ? "1fr 1fr" : "1fr",
              gap: "24px",
            }}
          >
            {/* Punch In Map */}
            {hasPunchIn && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#10b981",
                    }}
                  />
                  <h3 style={{ margin: 0, fontSize: "18px", color: "#1f2937" }}>
                    Punch-In Location
                  </h3>
                </div>
                <div
                  style={{
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    overflow: "hidden",
                    marginBottom: "12px",
                  }}
                >
                  <iframe
                    src={punchInUrl}
                    style={{
                      width: "100%",
                      height: "350px",
                      border: "none",
                    }}
                    title="Punch-in location"
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "#f9fafb",
                    padding: "12px",
                    borderRadius: "8px",
                    fontSize: "13px",
                  }}
                >
                  <p style={{ margin: "0 0 4px 0", color: "#6b7280" }}>
                    <strong>Coordinates:</strong>
                  </p>
                  <p style={{ margin: 0, color: "#1f2937", fontFamily: "monospace" }}>
                    {record.punchInLatitude}, {record.punchInLongitude}
                  </p>
                  <a
                    href={`https://www.google.com/maps?q=${record.punchInLatitude},${record.punchInLongitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#3b82f6",
                      textDecoration: "none",
                      fontSize: "12px",
                      marginTop: "8px",
                      display: "inline-block",
                    }}
                  >
                    Open in Google Maps →
                  </a>
                </div>
              </div>
            )}

            {/* Punch Out Map */}
            {hasPunchOut && (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#ef4444",
                    }}
                  />
                  <h3 style={{ margin: 0, fontSize: "18px", color: "#1f2937" }}>
                    Punch-Out Location
                  </h3>
                </div>
                <div
                  style={{
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    overflow: "hidden",
                    marginBottom: "12px",
                  }}
                >
                  <iframe
                    src={punchOutUrl}
                    style={{
                      width: "100%",
                      height: "350px",
                      border: "none",
                    }}
                    title="Punch-out location"
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "#f9fafb",
                    padding: "12px",
                    borderRadius: "8px",
                    fontSize: "13px",
                  }}
                >
                  <p style={{ margin: "0 0 4px 0", color: "#6b7280" }}>
                    <strong>Coordinates:</strong>
                  </p>
                  <p style={{ margin: 0, color: "#1f2937", fontFamily: "monospace" }}>
                    {record.punchOutLatitude}, {record.punchOutLongitude}
                  </p>
                  <a
                    href={`https://www.google.com/maps?q=${record.punchOutLatitude},${record.punchOutLongitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#3b82f6",
                      textDecoration: "none",
                      fontSize: "12px",
                      marginTop: "8px",
                      display: "inline-block",
                    }}
                  >
                    Open in Google Maps →
                  </a>
                </div>
              </div>
            )}
          </div>

          {!hasPunchIn && !hasPunchOut && (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                color: "#9ca3af",
              }}
            >
              <p>No location data available for this attendance record.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Export components for use in ManageAttendance
export { MiniLocationMap, LocationModal };